import axios from 'axios';
import store from '@/store/store';

const otherUrl = axios.create({
    baseURL: process.env.VUE_APP_CORENROLL_MEMBER_API,
});

otherUrl.interceptors.request.use(config => {
    const token = store.getters.accessToken;
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
}, error => {
    return Promise.reject(error);
});

export default otherUrl;